import { Link } from "react-router-dom";
import { convertDate } from "utilities/helperFunction";

export default function TourCard(props) {
  const { tour } = props;

  // border-top-left-radius: 20px;
  // border-top-right-radius: 20px;
  return (
    <Link
      to={`/single-tour/${tour.id}`}
      className="card  border-success m-1 item d-block"
      style={{
        height: "350px",
        direction: "rtl",
        borderRadius: "25px",

        // borderTopLeftRadius: "25px",
        // borderTopRightRadius: "25px",
      }}
      key={tour.id + Math.random() * 50}
    >
      <Borders />
      <div className="" style={{ height: "48%" }}>
        <img
          src={tour.image}
          alt=""
          className="card-img-top round-card tour-border-color h-100"
          style={{
            objectFit: "fill",
            borderTopLeftRadius: "25px",
            borderTopRightRadius: "25px",
          }}
        />
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "tomato",
          color: "white",
          backgroundImage:
            "linear-gradient(to right, #b21729, #d8162e, #b21729)",
        }}
      >
        <div style={{ fontWeight: "bolds" }}>{tour.title}</div>
      </div>
      <div className="card-body size5 d-flex flex-column justify-content-around">
        <div className="row the-text">
          <div className="way-color col-5 font-regular">مدت:</div>
          <div
            className="col-7 digits fw-bold  "
            // style={{
            //   fontSize:
            //     tour.price.toString().length < 6
            //       ? 15
            //       : (13 * 12) / (tour.price.toString().length + 6),
            // }}
          >
            {tour.duration} روزه
          </div>
        </div>
        <div className="row the-text essential-accessories">
          <div className="way-color col-5 font-regular">تاریخ رفت:</div>
          <div className="col-7  fw-bold digits">
            {convertDate(tour.start_time)}
          </div>
        </div>
        <div className="row the-text essential-accessories">
          <div className="way-color col-5 font-regular">تاریخ برگشت:</div>
          <div className="col-7  fw-bold digits">
            {convertDate(tour.end_time)}
          </div>
        </div>

        <div className="row the-text price">
          <div className="way-color col-5 font-regular">قیمت:</div>
          <div
            className="col-7 digits fw-bold  price"
            style={{
              fontSize:
                tour.price.toString().length < 6
                  ? 15
                  : (13 * 12) / (tour.price.toString().length + 6),
            }}
          >
            {tour.price} تومان
          </div>
        </div>
        {/* <div className=" rounded tourLabel1 size3">{tour.city}</div> */}
        {/* {tour.duration != "" && (
          <div className=" rounded tourLabel2 size2  digits fw-bold">
            {tour.duration} روزه
          </div>
        )} */}
        <div className="row the-text">
          <div className="way-color col-5 font-regular">ظرفیت:</div>
          <div className="col-7 digits fw-bold ">
            {tour.max_participant > 0
              ? `${tour.max_participant} نفر`
              : "تکمیل شده"}
          </div>
        </div>
      </div>
    </Link>
  );
}

function Borders() {
  return (
    <>
      <div className="k-border" />
    </>
  );
}
